<div class="obelisk-view-container">
  <div class="header">
    <q-svg-wrapper [iconPath]="'project-icons/chevron-left'" class="shown-on-phones" style="cursor: pointer"
                   (click)="hideEvent.emit()"
    ></q-svg-wrapper>
    <span style="width: 24px" class="hidden-on-phones"></span>

    <span class="obelisk-name bold-20 margin-right-4 margin-left-4">{{ obelisk()['name'] }}</span>

    <q-svg-wrapper [iconPath]="'project-icons/close'" style="cursor: pointer"
                   (click)="closeObelisk.emit()"></q-svg-wrapper>
  </div>

  @if (obelisk().images?.length) {
    <div class="swiper-images-container">
      <swiper-container slides-per-view="auto"
                        centered-slides="true"
                        space-between="4"
                        init="false"
                        navigation="true"
                        observer="true"
                        observeSlideChildren="true"
      >
        @for (image of obelisk().images; track image) {
          <swiper-slide swiperSlide>
            <div class="swipe-img-card">
              <img [src]="image.uri" alt="" (click)="previewImage.emit(image.uri)">
              @if (image.description) {
                <lib-show-more-less class="margin-left-12 regular-12 secondary-text-color" style="width: calc(100% - 24px)" [text]="image.description" [minimizedRows]="1"></lib-show-more-less>
              }
            </div>
            <!--        <span *ngIf="image.filePath === 'loading'" style="height: 50px;">Loading image...</span>-->
            <!--        <span *ngIf="image.filePath === 'error'" style="height: 50px;">Failed to load</span>-->
          </swiper-slide>
        }
      </swiper-container>
    </div>
  }

  @if (obelisk().category) {
    <div class="regular-16 secondary-text-color padding-x-16 margin-bottom-4 margin-top-4">
      <span>{{obelisk().category | transloco}}</span>
      @if (obelisk().subCategory) {
        <span class="margin-left-4 margin-right-4">-</span>
        <span>{{obelisk().subCategory | transloco}}</span>
      }
    </div>
  }

  @if (obelisk().subTitle) {
    <div class="semibold-16 margin-bottom-16 margin-top-12 text-centered">{{obelisk().subTitle}}</div>
  }

  @if (obelisk().address) {
    <div class="address-row">
      {{obelisk().address}}
    </div>
  }

  <div class="flex-vertical gap-12 padding-x-16 margin-top-12">
    <button class="secondary-btn centered-content" (click)="copyObeliskLink()">
      <q-svg-wrapper iconPath="project-icons/link" class="margin-right-4"></q-svg-wrapper>
      @if (!copiedLink) {
        {{'link' | transloco}}
      } @else {
        {{'copied' | transloco}}
      }
    </button>


    <div class="full-width">
      @if (obeliskDescription) {
        @for (par of obeliskDescription(); track par) {
          <div class="secondary-text-color">{{par}}</div>
        }
      } @else {
        <div class="full-width-container full-height-container centered-content semibold-20 secondary-text-color-soft">
          {{'noDescription' | transloco}}
        </div>
      }
    </div>
  </div>

  @if (obelisk().config?.["website"]) {
    <div class="padding-x-16 space-between gap-4 margin-top-12 margin-bottom-12" style="width: fit-content">
      <q-svg-wrapper iconPath="project-icons/planet-20"></q-svg-wrapper>
      <a href="#" (click)="navToExternalUrl($event, obelisk().config['website'])">{{obelisk().config['website']}}</a>
    </div>
  }

  @if (obelisk().config?.['howToGet']) {
    <div class="info-section">
      <div class="semibold-18">{{'howToGetToThePlace' | transloco}}</div>
      <div class="secondary-text-color margin-top-4">{{obelisk().config['howToGet']}}</div>
    </div>
  }

  <div class="padding-16 regular-14 secondary-text-color">{{'forMoreInfoDownloadTheApp' | transloco}}:</div>
  <div class="full-width flex gap-8 padding-x-16">
    @if (!hideDownloadIOS()) {
      <a href="https://apps.apple.com/ua/app/questatlas/id6461825089" target="_blank"><img style="width: 150px; height: 50px" src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="Download on the App Store"/></a>
    }
    @if (!hideDownloadAndroid()) {
      <a href="https://play.google.com/store/apps/details?id=world.app.questatlas" target="_blank"><img style="width: 170px; height: 50px" src="assets/images/google-play-badge.svg" alt="Get it on Google Play"/></a>
    }
  </div>
</div>
